import { motion } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";

const RaiseYourVoiceSection = () => {
  return (
    <section
      className="relative py-24 px-4 bg-gradient-to-b from-orange-50 via-white to-green-50 text-gray-800 overflow-hidden"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1605011031070-e87e145f3c3e?auto=format&fit=crop&w=1600&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundBlendMode: "overlay",
      }}
    >
      <div className="absolute inset-0 bg-white/70 backdrop-blur-md z-0" />

      <div className="relative z-10 max-w-5xl mx-auto text-center space-y-8">
        <motion.h2
          className="text-4xl sm:text-5xl font-extrabold text-orange-700 drop-shadow"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          ✊ अपनी आवाज़ उठाओ — बदलाव लाओ
        </motion.h2>

        <motion.p
          className="text-lg sm:text-xl text-gray-700"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          गाँव, शहर, पंचायत या संसद — आपकी आवाज़ भारत की असली ताकत है।
          <br />
          जनप्रतिनिधियों को ज़िम्मेदार बनाएं और लोकतंत्र को सशक्त करें।
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row justify-center gap-6 pt-4"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6 }}
        >
          <Link
            to="/issues"
            className="bg-green-700 hover:bg-green-800 text-white font-bold px-6 py-3 rounded-full shadow-lg transition"
          >
            🚩 Raise an Issue
          </Link>
          <Link
            to="/register"
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 py-3 rounded-full shadow-lg transition"
          >
            🇮🇳 Join the Movement
          </Link>
        </motion.div>

        <p className="text-sm italic text-gray-600 pt-2">
          “जन-जन की आवाज़, भारत की ताकत” — Team JanShakti 🇮🇳
        </p>
      </div>
    </section>
  );
};

export default RaiseYourVoiceSection;
